export var HttpVerbs;
(function (HttpVerbs) {
    HttpVerbs["POST"] = "POST";
    HttpVerbs["GET"] = "GET";
    HttpVerbs["PUT"] = "PUT";
    HttpVerbs["DELETE"] = "DELETE";
    HttpVerbs["PATCH"] = "PATCH";
    HttpVerbs["OPTIONS"] = "OPTIONS";
    HttpVerbs["HEAD"] = "HEAD";
    HttpVerbs["TRACE"] = "TRACE";
})(HttpVerbs || (HttpVerbs = {}));
